<template>
  <v-container>
    <v-row>
      <v-col>
        <v-sheet
          outlined
          class="rounded-lg story-list-container pa-3"
        >
          <v-container>
            <v-row>
              <v-col><h1>Bank Connection</h1></v-col>
            </v-row>
            <v-row v-show="!accountSetupComplete && !$apollo.queries.refreshStripeAccountUser.loading">
              <v-col>
                <p>{{ $t('becomeACreator.houseKeeping.addBankingInfoToGetPaid') }}</p>
                <p>{{ $t('becomeACreator.houseKeeping.connectBankInfo') }}</p>
              </v-col>
            </v-row>
            <v-row v-show="accountSetupComplete && !$apollo.queries.refreshStripeAccountUser.loading">
              <v-col>
                <p>{{ $t('becomeACreator.houseKeeping.readyToSell') }}</p>
                <p>{{ $t('becomeACreator.houseKeeping.goForthAndCreate') }}</p>
                <v-btn :to="{ name: 'creator-dashboard' }" color="primary">{{ $t('becomeACreator.lastStepsContent.goToDashboard') }}</v-btn>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col md="6" cols="10" offset="1" class="offset-md-3 mt-5">
                <div v-if="forwarding">
                <v-progress-circular  indeterminate /> <br />
                <p>{{ $t('becomeACreator.houseKeeping.forwardingYouToStripe') }}</p>
                </div>
                <v-alert v-else-if="needToFinishAccountSetup" type="warning">{{ $t('becomeACreator.houseKeeping.stripeStatus.setupIncomplete') }}</v-alert>
                <v-alert v-else-if="accountSetupComplete" type="success">{{ $t('becomeACreator.houseKeeping.stripeStatus.connected') }}</v-alert>
                <v-progress-circular v-else-if="$apollo.queries.refreshStripeAccountUser.loading" indeterminate />
              </v-col>
            </v-row>
            <v-row>
                  <v-col v-show="needToCreateAccount">
                    <CreateStripeAccountButton :forwarding="forwarding" @forwarding="forwarding = $event"/>
                  </v-col>
                  <v-col v-show="needToFinishAccountSetup">
                    <ContinueStripeAccountButton :forwarding="forwarding" @forwarding="forwarding = $event" />
                  </v-col>
              </v-row>
              <v-row>
                <v-col cols="10" sm="8" lg="6" class="offset-sm-2 offset-lg-3">
                  <v-sheet color="lightBackground" class="rounded-xl px-5 mt-10" >
                    <v-row align="center">
                      <v-col class="text-center">{{ $t('becomeACreator.houseKeeping.stripeAssurance') }} <span v-if="!accountSetupComplete">{{ $t('becomeACreator.houseKeeping.stripeRedirectDisclaimer')}}</span></v-col>
                    </v-row>
                    <v-row>
                      <v-col class="text-left" style="opacity: 0.3">
                        <v-img class="mx-auto" max-width="200px" :src="require('@/assets/stripeLogo.svg')" />
                      </v-col>
                    </v-row>
                  </v-sheet>
                </v-col>
              </v-row>
          </v-container>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { REFRESH_ACCOUNT } from "@/graphql/Stripe";
import CreateStripeAccountButton from "./CreateStripeAccountButton";
import ContinueStripeAccountButton from "./ContinueStripeAccountButton.vue";
export default {
  components: {
    CreateStripeAccountButton,
    ContinueStripeAccountButton,
  },
  data() {
    return {
      forwarding: false,
    };
  },
  apollo: {
    refreshStripeAccountUser: {
      query: REFRESH_ACCOUNT,
      pollInterval: 10000,
    },
  },
  computed: {
    REFRESH_ACCOUNT() {
      return REFRESH_ACCOUNT;
    },
    needToCreateAccount() {
      if (
        this.refreshStripeAccountUser &&
        !this.refreshStripeAccountUser.stripeAccount
      ) {
        return true;
      }
      return false;
    },
    needToFinishAccountSetup() {
      if (
        this.refreshStripeAccountUser &&
        this.refreshStripeAccountUser.stripeAccount &&
        !this.refreshStripeAccountUser.stripeAccount.chargesEnabled
      ) {
        return true;
      }
      return false;
    },
    accountSetupComplete() {
      if (
        this &&
        this.refreshStripeAccountUser &&
        this.refreshStripeAccountUser.stripeAccount &&
        this.refreshStripeAccountUser.stripeAccount.chargesEnabled
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>